import { auth } from '../firebase/firebase.js';

/**
 * Send the signed-in user's Firebase ID token with every request an axios
 * instance makes to the Gold Finder API.
 *
 * The API checks it: /service/api/admin/* needs a valid token carrying the
 * `admin` claim (gold-finder-api helpers/auth.js). Until 2026-10-08 the API
 * checked nothing and the admin flag lived only in the browser.
 * `getIdToken()` returns the cached token and refreshes it when it is close to
 * expiry, so this costs nothing per request. Signed out: no header, and the
 * public routes answer as before.
 */
export async function authorize(config) {
  const user = auth.currentUser;
  if (!user) return config;
  const token = await user.getIdToken();
  if (config.headers && typeof config.headers.set === 'function') {
    config.headers.set('Authorization', `Bearer ${token}`);
  } else {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
  }
  return config;
}

export function withAuth(instance) {
  instance.interceptors.request.use(authorize);
  return instance;
}
